import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IApiResponseBody } from '../../../common/models/common';
import { RootState } from '../../app.model';
import { booleanLookup } from '../../../common/constants/common';
import {
  deleteO365CopilotUsage,
  getO365CopilotUsageById,
  saveO365CopilotUsage,
  searchO365CopilotUsage,
} from './o365-copilot-usage.action';
import { IO365CopilotUsageState } from './o365-copilot-usage.model';
import { IO365CopilotUsage } from '../../../services/o365/o365-copilot-usage/o365-copilot-usage.model';

export const initialState: IO365CopilotUsageState = {
  search: {
    loading: false,
    hasErrors: false,
    data: [],
    count: 0,
    lookups: {},
    tableName: '',
  },
  tableColumnSelection: {
    id: null,
    table_name: null,
    columns: {},
  },
  getById: {
    loading: false,
    hasErrors: false,
    data: null,
  },
  save: {
    loading: false,
    hasErrors: false,
    messages: [],
  },
  delete: {
    loading: false,
    hasErrors: false,
    messages: [],
  },
};

export const o365CopilotUsageSlice = createSlice({
  name: 'o365CopilotUsage',
  initialState,
  reducers: {
    clearO365CopilotUsage: () => {
      return initialState;
    },
    clearO365CopilotUsageMessages: (state) => {
      state.save.messages = [];
      state.delete.messages = [];
    },
    clearO365CopilotUsageGetById: (state) => {
      state.getById.data = null;
    },
    setTableColumnSelection: (state, action: PayloadAction<{ [key: string]: boolean }>) => {
      state.tableColumnSelection.columns = action.payload;
    },
  },
  extraReducers: {
    [searchO365CopilotUsage.pending.type]: (state) => {
      state.search.loading = true;
    },
    [searchO365CopilotUsage.fulfilled.type]: (
      state,
      action: PayloadAction<any>
    ) => {
      const payload = action.payload;
      const { search_result, ...rest } = payload;
      state.search.data = search_result.records;
      state.search.count = search_result.total_count;
      if (JSON.stringify(rest) !== '{}') {
        state.search.lookups = { ...rest, booleanLookup };
      }
      state.search.loading = false;
      state.search.hasErrors = false;
      state.search.tableName = search_result.table_name;
      if (search_result.column_selection) {
        state.tableColumnSelection.id = search_result.column_selection.id;
        const tableSelectionObj = JSON.parse(search_result.column_selection.columns as any);
        if (tableSelectionObj.columns) {
          state.tableColumnSelection.column_orders = tableSelectionObj.column_orders;
          state.tableColumnSelection.columns = tableSelectionObj.columns;
        } else {
          state.tableColumnSelection.columns = tableSelectionObj;
        }
      }
      state.tableColumnSelection.table_name = search_result.table_name;
    },
    [searchO365CopilotUsage.rejected.type]: (state) => {
      state.search.loading = false;
      state.search.hasErrors = true;
    },
    [getO365CopilotUsageById.pending.type]: (state) => {
      state.getById.loading = true;
    },
    [getO365CopilotUsageById.fulfilled.type]: (state, action: PayloadAction<IO365CopilotUsage>) => {
      state.getById.data = action.payload;
      state.getById.loading = false;
      state.getById.hasErrors = false;
    },
    [getO365CopilotUsageById.rejected.type]: (state) => {
      state.getById.loading = false;
      state.getById.hasErrors = true;
    },
    [saveO365CopilotUsage.pending.type]: (state) => {
      state.save.messages = [];
      state.save.loading = true;
    },
    [saveO365CopilotUsage.fulfilled.type]: (state, action: PayloadAction<IApiResponseBody<unknown>>) => {
      state.save.loading = false;
      state.save.hasErrors = false;
      state.save.messages = action.payload?.messages || [];
    },
    [saveO365CopilotUsage.rejected.type]: (state) => {
      state.save.loading = false;
      state.save.hasErrors = true;
    },
    [deleteO365CopilotUsage.pending.type]: (state) => {
      state.delete.messages = [];
      state.delete.loading = true;
    },
    [deleteO365CopilotUsage.fulfilled.type]: (state, action: PayloadAction<IApiResponseBody<unknown>>) => {
      state.delete.loading = false;
      state.delete.hasErrors = false;
      state.delete.messages = action.payload?.messages || [];
    },
    [deleteO365CopilotUsage.rejected.type]: (state) => {
      state.delete.loading = false;
      state.delete.hasErrors = true;
    },
  },
});

export const {
  clearO365CopilotUsage,
  clearO365CopilotUsageMessages,
  clearO365CopilotUsageGetById,
  setTableColumnSelection,
} = o365CopilotUsageSlice.actions;

export const o365CopilotUsageSelector = (state: RootState) => state.o365CopilotUsage;

export default o365CopilotUsageSlice.reducer;
